const settings = {
  advanced: 'Advanced',
  censoredWords: 'Censored words',
  general: 'General',
  language: 'Language',
  settings: 'Settings',
  timeZone: 'Time zone',
  timeZoneDevice: 'Same as this device',
};

export default settings;
